import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import loadingIcon from '../assets/images/loading-icon.jpg';

const LoadingScreen = ({ quote }) => {
  return (
    <LoadingContainer>
      <LoadingContent>
        <LogoContainer>
          <Logo src={loadingIcon} alt="Stoic Wisdom" />
          <Spinner />
        </LogoContainer>
        <LoadingQuote>"{quote}"</LoadingQuote>
        <LoadingText>Loading wisdom...</LoadingText>
      </LoadingContent>
    </LoadingContainer>
  );
};

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
`;

const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: ${css`${fadeIn} 0.5s ease-in-out`};
`;

const LoadingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  padding: 2rem;
`;

const LogoContainer = styled.div`
  position: relative;
  margin-bottom: 2rem;
`;

const Logo = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--color-primary);
  box-shadow: 0 0 20px rgba(192, 192, 192, 0.3);

  @media (max-width: 768px) {
    width: 120px;
    height: 120px;
  }
`;

const Spinner = styled.div`
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  border: 2px solid transparent;
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: ${css`${spin} 1.5s linear infinite`};
`;

const LoadingQuote = styled.p`
  font-family: var(--font-primary);
  font-size: 1.5rem;
  text-align: center;
  color: var(--color-primary);
  margin-bottom: 2rem;
  line-height: 1.4;
  animation: ${css`${pulse} 2s infinite ease-in-out`};

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const LoadingText = styled.p`
  font-family: var(--font-secondary);
  font-size: 1rem;
  color: var(--color-secondary);
  letter-spacing: 2px;
  animation: ${css`${pulse} 1.5s infinite ease-in-out`};
`;

export default LoadingScreen;
